import { render, staticRenderFns } from "./TiposDicasSaude.vue?vue&type=template&id=6cfab048&scoped=true&"
import script from "./TiposDicasSaude.vue?vue&type=script&lang=js&"
export * from "./TiposDicasSaude.vue?vue&type=script&lang=js&"
import style0 from "./TiposDicasSaude.vue?vue&type=style&index=0&id=6cfab048&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfab048",
  null
  
)

export default component.exports